import _ from "lodash";

export const normalizeStr = (str: string) => _.chain(str).lowerCase().upperFirst().value();
